import {UtilService} from './util.service';
import {Item, Category, Extra} from '../models/menu.model';
import { Injectable } from '@angular/core';
import { DBService } from '../services/db.service';

@Injectable({
  providedIn: 'root'
})
export class ExtraService {

  //hier wird extra liste gespeichert werden, fuer ein abgleich (in einem dictionary)
    //testen ob neue hinzugekommen sind und falls die neuen aktiv sind, frage ob auch aktiv in unteritems
  orgExtras: { [name: string]: Extra } = {};

  constructor(private db:DBService, private util:UtilService) { }


  storeExtrasOrgState(cat:Category){
    this.orgExtras = {};
    if(!cat.extras) cat.extras = []
    for(let e of cat.extras) this.orgExtras[e.name] = Object.assign(new Extra(e.name,e.price),e);
  }


  updateExtraItems(updatedCat:Category){
    //todo hier aus res.data.extras nehmen, vergleichen mit der vorherigen liste und dann folgende punkte durchführen:
    //Ein extra wurde deaktiviert? => das extra in den items deaktivieren
    //Ein extra wurde aktiviert? => das extra in den items aktivieren
    //Ein extra wurde entfernt? => das extra in den items entfernen
    //Ein extra wurde hinzugefügt? => das extra in den items hinzufügen; und so schalten wie es ist
    //WAS IST MIT PREISAENDERUNGEN!!!!!!
    
    //TODO +++ funktioniert bei subcategories nicht
    let dbCat:Category = this.db.findCategoryByCat(updatedCat)  //wird benoetigt um die richtige Referenz zu haben
    if(!dbCat) return
    if(!dbCat.extras) dbCat.extras = []
    if(!updatedCat.extras) updatedCat.extras = []

    //kann es sein, wenn ich extras aendere, dass die in der orgListe auch geandert sind????
    //console.error("FuerAllVorsp",this.orgExtras['FuerAllVorsp'])
    for(let e of updatedCat.extras){
      if(!this.orgExtras[e.name]){  //Extra ist neu hinzugekommen
        this.util.info("Neues Extra ist hinzugekommen",e)
        this.util.info("Extra wird Items hinzugefuegt",dbCat.items)
        for(let item of dbCat.items) this.addExtraToItem(item,e) 
      } 
      else if(this.orgExtras[e.name].isActive && !e.isActive){  //wurde deaktiviert
        this.util.info("Extra wurde deaktiviert",e)
        this.util.info("Extra wird in Items aktualisiert",dbCat.items)
        for(let item of dbCat.items) this.addExtraToItem(item,e) 
      }else if(!this.orgExtras[e.name].isActive && e.isActive){ //wurde aktiviert
        this.util.info("Extra wurde aktiviert",e)
        this.util.info("Extra wird in Items aktualisiert",dbCat.items)
        for(let item of dbCat.items) this.addExtraToItem(item,e) 
      }else if(this.orgExtras[e.name].price !== e.price){ //Price geandert
        this.util.info("Extra wurde Preis geandert",e)
        this.util.info("Extra wird in Items aktualisiert",dbCat.items)
        for(let item of dbCat.items) this.addExtraToItem(item,e) 
      }else{
        //Sicherstellen, dass das Extra auch in allen Items ist mit gleichem Status
        for(let item of dbCat.items) this.addExtraToItem(item,e) 
      }
      // this.norm(dbCat.items)
    }

    this.util.info("Bevor Extras von Org Liste geloescht werden",this.orgExtras)
    for(let e of updatedCat.extras){
      delete this.orgExtras[e.name]
    }
    this.util.info("Nach Extras von Org Liste geloescht werden",this.orgExtras)

    //die wo hier uebrig bleiben in orgExtras wurden geloescht
    for(let extraNames of Object.keys(this.orgExtras)){
      for(let item of dbCat.items) this.deleteExtraFromItem(item,this.orgExtras[extraNames])
    }
  }

  /**
   * Methode fuegt hinzu aber passt auch Status und Preise an
   * @param item 
   * @param newExtra 
   */
  addExtraToItem(item:Item, newExtra:Extra){
    if(!item) return
    if(!item.extras) item.extras = []
    for(let extra of item.extras){
      if(extra.name === newExtra.name){  //gibt es schon, jetzt muss der Status gesetzt werden
        this.util.info('Extra wurde in Item gefunden und wird aktualisiert',item, newExtra)
        extra.isActive = newExtra.isActive
        extra.price = newExtra.price
       // extra.position += (newExtra.position - (extra.position)) //+ 0.1
        this.util.info('Extra wurde in Item gefunden und wurde aktualisiert',item, newExtra)
        this.norm(item.extras)
        return //kein neues hinzufuegen
      }
    }

    this.util.info('Extra wurde NICHT in Item gefunden und wird nun hinzugefuegt',item, newExtra)
    newExtra.position = 9999
    item.extras.push(newExtra)
    this.norm(item.extras)
  }

  deleteExtraFromItem(item:Item, newExtra:Extra){
    if(!item) return
    if(!item.extras) item.extras = []

    let newExtraList:Extra[] = []

    for(let extra of item.extras){
      if(extra.name !== newExtra.name){  //gibt es schon, jetzt muss der Status gesetzt werden
        newExtraList.push(extra)
      }
    }

    item.extras = newExtraList
    this.norm(item.extras)
  }

  norm(extras){
    // *** Sort ***
    extras = extras.sort((n1,n2) => n1.position - n2.position);

    // *** Norm ***
    let i:number  = 0
    for(let extra of extras){
      extra.position = i++;
    }
  }

}
